import {
  missionTemplateReadResult,
  samePin,
  type ExactPin,
  type MissionTemplateReadPort,
  type MissionTemplateReadResult,
} from './contract';
export type MissionTemplateObservation =
  MissionTemplateReadResult | Readonly<{ status: 'ERROR'; authority: 'NON_AUTHORITY' }>;
/** Transport/decoding failures remain frontend conditions, never contract outcomes. */
export async function readMissionTemplate(
  port: MissionTemplateReadPort,
  query: ExactPin,
): Promise<MissionTemplateObservation> {
  try {
    const result = await port.read(query);
    if (!samePin(query, result.query)) throw new Error('Reader identity mismatch');
    return missionTemplateReadResult(result.status, result.query, result.snapshot);
  } catch {
    return Object.freeze({ status: 'ERROR', authority: 'NON_AUTHORITY' });
  }
}
